'use strict';

exports.__esModule = true;

var _styledBase = require('@emotion/styled-base');

var _styledBase2 = _interopRequireDefault(_styledBase);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return 'You have tried to stringify object returned from `css` function. It isn\'t supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).'; }

var DownloadSvgWrapper = (0, _styledBase2.default)('span', {
	target: 'e980kqx0',
	label: 'DownloadSvgWrapper'
})(process.env.NODE_ENV === 'production' ? {
	name: '1yiuic3',
	styles: 'text-decoration:underline;text-decoration-thickness:2px;position:relative;top:-1px;margin-left:2px;'
} : {
	name: '1yiuic3',
	styles: 'text-decoration:underline;text-decoration-thickness:2px;position:relative;top:-1px;margin-left:2px;',
	map: '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3NoYXJlZC9Eb3dubG9hZFN2Zy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHc0MiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc2hhcmVkL0Rvd25sb2FkU3ZnLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgRG93bmxvYWRTdmdXcmFwcGVyID0gc3R5bGVkLnNwYW5gXG5cdHRleHQtZGVjb3JhdGlvbjogdW5kZXJsaW5lO1xuXHR0ZXh0LWRlY29yYXRpb24tdGhpY2tuZXNzOiAycHg7XG5cdHBvc2l0aW9uOiByZWxhdGl2ZTtcblx0dG9wOiAtMXB4O1xuXHRtYXJnaW4tbGVmdDogMnB4O1xuYDtcblxuY29uc3QgRG93bmxvYWRTdmcgPSBwcm9wcyA9PiA8RG93bmxvYWRTdmdXcmFwcGVyIHsuLi5wcm9wc30+4qyHPC9Eb3dubG9hZFN2Z1dyYXBwZXI+O1xuXG5leHBvcnQgZGVmYXVsdCBEb3dubG9hZFN2ZztcbiJdfQ== */',
	toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var DownloadSvg = function DownloadSvg(props) {
	return _react2.default.createElement(
		DownloadSvgWrapper,
		props,
		'\u2B07'
	);
};

exports.default = DownloadSvg;